<script setup>
defineProps({
  color: {type: String, default: '#475467'},
});
</script>

<template>
  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.75008 9.99935L8.25008 12.4993L13.2501 7.49935M17.8334 9.99935C17.8334 14.6017 14.1025 18.3327 9.50008 18.3327C4.89771 18.3327 1.16675 14.6017 1.16675 9.99935C1.16675 5.39698 4.89771 1.66602 9.50008 1.66602C14.1025 1.66602 17.8334 5.39698 17.8334 9.99935Z"
      :stroke="color" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
